if (!customElements.get('tabbed-content')) {
  class Tabs extends HTMLElement {
    constructor() {
      super();
      this.initialized = false;
    }

    connectedCallback() {
      // Sections may be inserted after the script loads. Wait until their children exist.
      requestAnimationFrame(() => {
        if (!this.isConnected || this.initialized) return;

        this.tabList = this.querySelector('[role="tablist"]');
        if (!this.tabList) return;

        this.tabs = Array.from(this.tabList.querySelectorAll('[role="tab"]'));
        this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));
        if (!this.tabs.length || !this.panels.length ||
            this.tabs.some(tab => !this.panelFor(tab))) return;

        this.isVerticalTablist = this.tabList.getAttribute('aria-orientation') === 'vertical';
        this.activeTab = this.tabs.find(tab => tab.getAttribute('aria-selected') === 'true') || this.tabs[0];
        this.panels.forEach(panel => {
          panel.hidden = panel !== this.panelFor(this.activeTab);
        });
        this.tabs.forEach(tab => {
          tab.setAttribute('aria-selected', tab === this.activeTab ? 'true' : 'false');
          if (tab !== this.activeTab) tab.setAttribute('tabindex', '-1');
        });
        this.initialized = true;
        this.tabList.addEventListener('click', this.handleClick.bind(this));
        this.tabList.addEventListener('keydown', this.handleKeydown.bind(this));
      });
    }

    panelFor(tab) {
      const id = tab.getAttribute('aria-controls');
      return this.panels.find(panel => panel.id === id);
    }

    handleClick(evt) {
      const tab = evt.target.closest('[role="tab"]');
      if (tab && this.tabList.contains(tab)) this.activateTab(tab);
    }

    handleKeydown(evt) {
      let next;
      const index = this.tabs.indexOf(this.activeTab);
      if ((evt.key === 'ArrowRight' && !this.isVerticalTablist) ||
          (evt.key === 'ArrowDown' && this.isVerticalTablist)) {
        next = this.tabs[(index + 1) % this.tabs.length];
      } else if ((evt.key === 'ArrowLeft' && !this.isVerticalTablist) ||
                 (evt.key === 'ArrowUp' && this.isVerticalTablist)) {
        next = this.tabs[(index + this.tabs.length - 1) % this.tabs.length];
      } else if (evt.key === 'Home') {
        next = this.tabs[0];
      } else if (evt.key === 'End') {
        next = this.tabs[this.tabs.length - 1];
      }
      if (!next) return;
      evt.preventDefault();
      this.activateTab(next, true);
    }

    activateTab(tab, focus = false) {
      const panel = this.panelFor(tab);
      if (!panel || tab === this.activeTab) return;
      this.tabs.forEach(item => {
        item.setAttribute('aria-selected', item === tab ? 'true' : 'false');
        if (item === tab) item.removeAttribute('tabindex');
        else item.setAttribute('tabindex', '-1');
      });
      this.panels.forEach(item => { item.hidden = item !== panel; });
      this.activeTab = tab;
      if (focus || document.activeElement?.matches('.tablist__tab')) tab.focus();
    }
  }

  customElements.define('tabbed-content', Tabs);
}
